import {toast} from "react-toastify";

export default function useHandleToastAlert() {
    const success = (message) => toast.success(() => message);
    const error = (title, message = '') => toast.error(message ? `${title}: ${message}` : title);

    return {
        success, error,
    }
}